import React, {useEffect, useLayoutEffect} from 'react';
import {animated, useSpring} from 'react-spring';
import {MultiOption, SingleOption} from '../types/question';
import MultiOptions from './MultiOptions';
import QuestionContentWrapper from './QuestionContentWrapper';
import TypographyBody from './Typography/TypographyBody';
import {useIntersection} from 'react-use';
import Div from './Div.styled';
import useMediaQuery from '../hooks/useMediaQuery';
interface IQuestionMultiContainerProps {
  handleSubmitNext?: () => void;
  title: string;
  selectedOptions: MultiOption[] | SingleOption[];
  handleOptionChange: (option: MultiOption | SingleOption) => void;
  isDisabledButton: boolean;
  isMultiple?: boolean;
  subHeading?: string;
}
const QuestionMultiSelectorContainer = (
  props: IQuestionMultiContainerProps,
) => {
  const {
    subHeading,
    handleSubmitNext,
    title,
    selectedOptions,
    handleOptionChange,
    isDisabledButton,
  } = props;

  const {isDesktop} = useMediaQuery();
  const springs = useSpring<React.CSSProperties>({
    from: {opacity: 0},
    to: {opacity: 1},
    delay: 500,
    config: {
      duration: 500,
    },
  });

  const [isScrolled, setIsScrolled] = React.useState(false);

  const [overlayHeight, setOverlayHeight] = React.useState(150);

  const intersectionRef = React.useRef<HTMLDivElement>(null);

  const questionListRef = React.useRef<HTMLDivElement>(null);

  const intersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 1,
  });

  const isInView = intersection?.isIntersecting;

  const isShowFadeScrollIndicator = !isDesktop && !isInView && !isScrolled;

  useEffect(() => {
    const element = document.querySelector('.question-container');
    if (!element) return;

    function handleScroll() {
      if (isScrolled) return;
      setIsScrolled(true);
    }

    element.addEventListener('scroll', handleScroll);
    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolled]);

  useLayoutEffect(() => {
    const el = questionListRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const top = rect.top;

    const height = window.innerHeight - top;
    setOverlayHeight(height);
  }, []);

  return (
    <QuestionContentWrapper
      title={title}
      maxWidthTitle={'800px'}
      maxWidthContent={'400px'}
      disabled={isDisabledButton}
      handleClick={handleSubmitNext}
      label={
        subHeading && (
          <animated.div style={{...springs}}>
            <TypographyBody
              size="small"
              style={{
                marginTop: 28,
                fontSize: isDesktop ? 20 : 14,
              }}
            >
              {subHeading}
            </TypographyBody>
          </animated.div>
        )
      }
    >
      <Div ref={questionListRef} customStyles={{position: 'relative'}}>
        <MultiOptions
          handleOptionChange={handleOptionChange}
          selectedOptions={selectedOptions}
        />
      </Div>
      {isShowFadeScrollIndicator && (
        <Div
          customStyles={{
            bottom: 0,
            height: overlayHeight,
            width: '100%',
            position: 'fixed',
            background:
              'linear-gradient(180deg, rgb(0, 77, 199,0) 40%, rgb(0, 77, 199,0.8) 100%)',
            pointerEvents: 'none',
          }}
        ></Div>
      )}

      <div ref={intersectionRef}></div>
    </QuestionContentWrapper>
  );
};

export default QuestionMultiSelectorContainer;
